<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M18.9022 8.0625L14.1012 3.16875L13.6991 3H6.38656C6.01702 3.00517 5.66438 3.15561 5.4049 3.41878C5.14542 3.68194 4.99996 4.03668 5 4.40625L5 19.5938C4.99997 19.9638 5.14581 20.319 5.4059 20.5822C5.66598 20.8454 6.01935 20.9956 6.38937 21H17.6703C18.0408 20.9963 18.3949 20.8465 18.6556 20.5832C18.9163 20.3199 19.0625 19.9643 19.0625 19.5938V8.45344L18.9022 8.0625ZM14.2616 4.93781L17.1584 7.88812H14.5288C14.4566 7.88451 14.3886 7.8533 14.3389 7.80094C14.2892 7.74858 14.2615 7.67909 14.2616 7.60687V4.93781ZM17.6703 19.875H6.38937C6.31775 19.8707 6.25047 19.8392 6.20132 19.7869C6.15217 19.7346 6.12487 19.6655 6.125 19.5938V4.40625C6.12487 4.33449 6.15217 4.2654 6.20132 4.21311C6.25047 4.16083 6.31775 4.12931 6.38937 4.125H13.1394V7.60969C13.1394 7.98022 13.2856 8.33579 13.5463 8.59912C13.807 8.86244 14.161 9.01223 14.5316 9.01594H17.9375V19.5938C17.9376 19.666 17.9099 19.7355 17.8602 19.7878C17.8104 19.8402 17.7424 19.8714 17.6703 19.875Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
